<template>
  <Teleport to="body">
    <Transition name="notify-fade">
      <div v-if="visible" class="global-notify" :class="typeClass">
        <span>{{ message }}44</span>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup>
import { ref, computed, onBeforeUnmount } from 'vue'

const props = defineProps({
  type: { type: String, default: 'success' },
  message: String,
  duration: { type: Number, default: 1000 }
})

const visible = ref(false)
const timer = ref(null)

const typeClass = computed(() => `notify-${props.type}`)  // 使用计算属性优化样式类名

const show = () => {
  visible.value = true
  timer.value = setTimeout(() => (visible.value = false), props.duration)
}

onBeforeUnmount(() => timer.value && clearTimeout(timer.value))  // 清理定时器[7](@ref)

defineExpose({ show })  // 显式暴露方法供外部调用[8](@ref)
</script>

<style scoped>
.global-notify {
  /* 布局定位 */
  position: fixed;
  top: 24px;
  left: 50%;
  transform: translateX(-50%);
  
  /* 尺寸形状 */
  min-width: 280px;
  max-width: 80vw;
  padding: 12px 32px;
  border-radius: 2px;
  
  /* 视觉表现 */
  background: rgba(64, 64, 64, 0.9); /* 半透明深灰背景 */
  color: rgba(255, 255, 255, 0.95); /* 半透明白色文字 */
  backdrop-filter: blur(5px); /* 毛玻璃效果[7](@ref) */
  border: 1px solid rgba(255, 255, 255, 0.1); /* 浅色描边增强层次 */
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15); /* 柔和投影 */

  /* 文字样式 */
  font-size: 14px;
  letter-spacing: 0.5px;
  text-align: center;
  white-space: nowrap; /* 禁止换行保持长条形态 */
  
  /* 层级管理 */
  z-index: 9999;
}

/* 状态类型改造 */
/* 增加文字颜色定义 */
.notify-success {
  background: #67c23a;
  color: white !important;  /* 网页2/7强调对比色 */
  box-shadow: 0 2px 12px rgba(103, 194, 58, 0.3); /* 网页3建议增加层次感 */
}


.notify-error {
  background: rgba(245, 108, 108, 0.9); /* 带透明度的错误红 */
  border-color: rgba(245, 108, 108, 0.3);
}

.notify-warning {
  background: rgba(230, 162, 60, 0.9); /* 带透明度的警告橙 */
  border-color: rgba(230, 162, 60, 0.3);
}

/* 动画优化 */
.notify-fade-enter-active {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1); /* 顺滑入场曲线 */
}

.notify-fade-leave-active {
  transition: all 0.15s cubic-bezier(0.4, 0, 1, 1); /* 快速离场曲线 */
}

.notify-fade-enter-from,
.notify-fade-leave-to {
  opacity: 0;
  transform: translate(-50%, -30px); /* 垂直方向动画路径 */
}
</style>
